import axios from 'axios';
import { getIdByUrl } from '../helpers/navigationHelpers/navigationHelpers';

import {
	FETCH_INITIAL_PAGE_FULFILLED,
	FETCH_PAGE_PENDING,
	FETCH_PAGE_FULFILLED,
	FETCH_PAGE_FAILED,
	FETCH_PAGE_SETTINGS_PENDING,
	FETCH_PAGE_SETTINGS_FULFILLED,
	FETCH_PAGE_SETTINGS_FAILED
} from '../constants/page.actions';
import { API_BASE_URL } from '../constants/api.paths.js';
import sleep from '../helpers/sleep';
import { theme } from '../components/global';
import { closeMobileNav } from './navigationActions';

export const fetchInitialPageFulfilled = (page) => {
	return {
		type: FETCH_INITIAL_PAGE_FULFILLED,
		payload: {
			page
		}
	};
};

export const fetchPagePending = () => {
	return {
		type: FETCH_PAGE_PENDING,
		payload: null
	};
};

export const fetchPageFulfilled = (page) => {
	return {
		type: FETCH_PAGE_FULFILLED,
		payload: {
			page
		}
	};
};

export const fetchPageFailed = (status) => {
	return {
		type: FETCH_PAGE_FAILED,
		payload: {
			status
		}
	};
};

export const fetchPage = (url) => {
	return async function(dispatch, getState) {
		const { navigation } = getState().navigationReducer;
		const { pages } = getState().pageReducer;
		const id = getIdByUrl(url, navigation);

		// The reducer holds a memory bank of all previous fetched pages
		// If we already have the page we're navigating to, there's no need to fetch it again
		if(pages[id] !== undefined) {
			// Await the exit transitions of the current route we're on
			// because we are vain and want to watch animations
			await sleep(theme.routeTransitions.exitDuration);
			dispatch(fetchPageFulfilled(pages[id]));
			return;
		}

		dispatch(fetchPagePending());

		try {
			const response = await axios(`${API_BASE_URL}/page/${id}`);
			dispatch(fetchPageFulfilled(response.data));
		} catch(error) {
			dispatch(fetchPageFailed(error.request.status));
		}
	};
};

export const routeLocationUpdated = (url) => {
	return (dispatch) => {
		// If the night theme has been set on the frontpage
		// we have to turn it off when navigating so the global
		// night theme styles don't leak of onto other sites that
		// don't use theme. Night theme is only used on the frontpage right now.
		// const { isNightTheme } = getState().themeReducer;
		// if(isNightTheme) dispatch(setDayTheme());

		// Dispatch the action to fetch the actual page
		// Further on, this might not be applicable for every single
		// route we're navigating to so we might not something else here.
		// Fx. /products/1232837 might not be interested in the umbraco node
		// at all once we're client side, all we would need is the product itself
		// from a separate end point.
		dispatch(closeMobileNav());
		dispatch(fetchPage(url));
	};
};

export const fetchPageSettingsPending = () => {
	return {
		type: FETCH_PAGE_SETTINGS_PENDING,
		payload: null
	};
};

export const fetchPageSettingsFulfilled = (page) => {
	return {
		type: FETCH_PAGE_SETTINGS_FULFILLED,
		payload: {
			page
		}
	};
};

export const fetchPageSettingsFailed = (status) => {
	return {
		type: FETCH_PAGE_SETTINGS_FAILED,
		payload: {
			status
		}
	};
};

export const fetchPageSettings = () => {
	return async function(dispatch) {
		dispatch(fetchPageSettingsPending());

		try {
			const response = await axios(`${API_BASE_URL}/page/3771`);
			dispatch(fetchPageSettingsFulfilled(response.data));
		} catch(error) {
			dispatch(fetchPageSettingsFailed(error.request.status));
		}
	};
};
